module.exports = __webpack_public_path__ + "static/house-glass-df1e475c44933f3db627115619ba2d7a.jpg";